import { useAppSelector } from '@src/core/hooks';
import { uiStateSelector } from '@src/stores/ui';
import { useEffect, useState } from 'react';

const useMediaQuery = (breakpoint: string) => {
  const [isInsideWindowSize, setIsInsideWindowSize] = useState(false);

  const { screenWidth } = useAppSelector(uiStateSelector);

  useEffect(() => {
    const handleResize = () => {
      const targetWindowSize = parseInt(breakpoint);

      setIsInsideWindowSize(screenWidth !== undefined && screenWidth <= targetWindowSize);
    };

    handleResize();
  }, [breakpoint, screenWidth]);

  return isInsideWindowSize;
};

export default useMediaQuery;
